import { Box, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import "firebase/compat/auth";
import { useUserContext } from "../../providers/userProvider";
import { useCustomThemeContext } from "../../providers/customThemeProvider";
import EventOverview from "../../components/events/EventOverview";
import { useEventContext } from "../../providers/EventProvider";

export const HomePage: FC = () => {
  const { userDetails } = useUserContext();
  const { updateTheme } = useCustomThemeContext();
  const { upcomingEvents = [] } = useEventContext();

  // Update the theme when the component mounts
  useEffect(() => {
    updateTheme();
  }, []);

  return (
    <Box
      sx={{
        maxWidth: "100%",
        textAlign: "center",
        padding: 2,
        flexDirection: "column",
        minHeight: "84vh",
      }}
    >
      {/* Display a welcome message with the user's first name */}
      <Typography variant="h2" align="center" margin={5} marginBottom={5}>
        Welcome at Re-Evented{userDetails?.firstName && `, ${userDetails.username}`}!
      </Typography>
      {/* If there are no upcoming events, display a message */}
      {!upcomingEvents && <>
        <Typography variant="h4" align="center" margin={5} marginBottom={5}>
          No events planned.
        </Typography>
      </>}
      {/* If there are upcoming events, display the EventOverview component */}
      {upcomingEvents?.length > 0 && <>
        <Typography variant="h4" align="center" margin={5} marginBottom={5}>
          Upcoming events
        </Typography>
        <EventOverview />
      </>}
    </Box>
  );
};

export default HomePage;
